import * as SharedEnvironment from './environment.shared';

export const environment = {
    ...SharedEnvironment.environment,

    api: `https://api.app.fintrax.io/`,
    production: true,
    showExperimentalFeatures: false,

    tracesSampleRate: 0.3,
    replaysSessionSampleRate: 0.1,
    sentryEnvironment: 'production',
};

SharedEnvironment.injectEndpoints(environment);
